import { readPointAchieveList } from '@/api/point/read';
import { ChangeEvent, Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Unstable_Grid2';
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import { AddIndexResReadPointAchieveListType, ResReadPointAccumulatedListType } from '@/types';
import { compareArrays } from '@/lib/Compare';
import { updatePointAccumulated, updatePointAchieve } from '@/api/point/update';
import { sleep } from '@/lib/util';
import Loading from '@/component/mui/Backdrop';
import { toast } from 'react-toastify';

export default function PointSettingAchieveList({ settingId, refresh }: { settingId: string; refresh: number }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState<AddIndexResReadPointAchieveListType[] | []>([]);
  const [oldList, setOldList] = useState<AddIndexResReadPointAchieveListType[] | []>(list);

  useEffect(() => {
    if (!settingId) {
      navigate('/point-setting-list');
    }

    return () => {};
  }, [settingId, navigate]);

  useEffect(() => {
    (async () => {
      const re = await readPointAchieveList(settingId);
      if (re.status !== 200) {
        return;
      }
      const list: AddIndexResReadPointAchieveListType[] = re.data.map(
        (item: ResReadPointAccumulatedListType, index: number) => ({
          index: index,
          ...item,
        }),
      );
      setList(list);
      setOldList(list);
    })();
    return () => {};
  }, [refresh]);

  const handleChangeValue = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
    const { name, value } = e.target;
    if (!name) {
      return;
    }
    if (!list || !oldList) {
      return;
    }
    setList((prev) =>
      prev
        ? prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  [name]: value,
                }
              : item,
          )
        : prev,
    );
  };
  const onSubmitUpdate = async () => {
    if (!list || !oldList) {
      return;
    }
    setIsLoading(true);
    const datas = compareArrays(list, oldList); // .filter((item) => Object.keys(item).length > 0);
    if (!datas) {
      return;
    }

    let arr = [];
    for (let i = 0; i < list.length; i++) {
      const element = list[i];
      if (Object.keys(datas[i]).length > 0) {
        const temp = {
          achieveSetId: element.achieveSetId,
          ...datas[i],
        };
        arr.push(temp);
      }
    }
    const failedList = [];
    for (const iter of arr) {
      try {
        await updatePointAchieve(iter);
        await sleep(1000);
      } catch (e) {
        failedList.push(iter);
      }
    }
    setIsLoading(false);
    if (failedList.length > 0) {
      toast.error(`${failedList.length}건 실패하였습니다.`);
    } else {
      toast.success('성공');
    }
  };

  return (
    <>
      {/* {list[0] && (
        <>
          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <Typography variant="h6">season: {list[0].season}</Typography>
            </Grid>
            <Grid xs={6}>
              <Typography variant="h6">code: {list[0].code}</Typography>
            </Grid>
          </Grid>
        </>
      )} */}

      <Divider />
      <Box mb={3} />
      {list.length > 0 && (
        <>
          {list.map((item: AddIndexResReadPointAchieveListType) => (
            <Fragment key={item.index}>
              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <Typography variant="h6">No.{item.index}</Typography>
                </Grid>
                {/* <Grid xs={6}>
                  <Button onClick={() => onSubmitUpdate()}>변경</Button>
                </Grid> */}
              </Grid>

              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>amount</InputLabel>
                    <OutlinedInput
                      type="text"
                      value={item.amount}
                      label="amount"
                      name="amount"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                    <FormHelperText>※ 사용자가 받는 포인트</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>Title</InputLabel>
                    <OutlinedInput
                      value={item.title}
                      label="title"
                      name="title"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Box mb={2} />
              <TextField
                name="describe"
                id="describe"
                label="describe"
                multiline
                rows={1}
                value={item.describe ?? ''}
                onChange={(e) => handleChangeValue(e, item.index)}
              />
              <FormHelperText>※ 설명</FormHelperText>
              <Box mb={5} />

              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>목표 포인트</InputLabel>
                    <OutlinedInput
                      type="string"
                      value={item.requireValue}
                      label="requireValue"
                      name="requireValue"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                    <FormHelperText>※ 목표 포인트(목표 포인트에 달성해야 사용자에게 amount 지급)</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <RadioGroup
                      row
                      name="radio-button"
                      aria-labelledby="group-type"
                      value={item.isActive}
                      onChange={(e) => handleChangeValue(e, item.index)}
                    >
                      <FormControlLabel value="0" control={<Radio />} label="비활성화" />
                      <FormControlLabel value="1" control={<Radio />} label="활성화" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Divider />
              <Box mb={5} />
            </Fragment>
          ))}
          <Button variant="outlined" fullWidth onClick={onSubmitUpdate}>
            변경
          </Button>
        </>
      )}
      <Loading isLoading={isLoading} />
    </>
  );
}

/**
 * 등록, 리스트
 *
 * 등록 할 때 멘트도 함께 나오게 해야 한다
 *
 * 화면 구성은??
 * 수량, usdt, 설명1, 설명2
 *
 */
